import axios from 'axios'
import { mainUrls } from 'utils/dotenv.util'

const api = axios.create({
  baseURL: mainUrls.nestApi
})

export default api
